import { render } from "./IcoPic.vue?vue&type=template&id=1cde6e3c"
import script from "./IcoPic.vue?vue&type=script&lang=js"
export * from "./IcoPic.vue?vue&type=script&lang=js"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__